var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducts3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5422 10.4521C15.1882 11.3941 13.255 11.3941 11.901 10.4521C10.5471 11.3941 8.61382 11.3941 7.25988 10.4521C6.58289 10.9223 5.78217 11.1798 4.9393 11.1798C4.33166 11.1798 3.75856 11.0375 3.23755 10.7948V17.3681C3.23755 18.0513 3.79201 18.6057 4.47519 18.6057H9.42574V13.6552H14.3763V18.6057H19.3269C20.01 18.6057 20.5645 18.0513 20.5645 17.3681V10.7948C20.0435 11.0375 19.4704 11.1798 18.8627 11.1798C18.0199 11.1798 17.2192 10.9223 16.5422 10.4521Z",
    fill: "#898989"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7838 8.41966L20.6637 3.93693C20.5263 3.38621 20.0312 3 19.4632 3H4.34032C3.77235 3 3.27729 3.38621 3.13861 3.93693L2.01851 8.41966C2.00622 8.46787 2 8.5187 2 8.56939C2 10.2749 3.31802 11.6635 4.93939 11.6635C5.88131 11.6635 6.72152 11.1944 7.25997 10.4667C7.79841 11.1944 8.63863 11.6635 9.58054 11.6635C10.5225 11.6635 11.3627 11.1944 11.9011 10.4667C12.4396 11.1944 13.2785 11.6635 14.2217 11.6635C15.1648 11.6635 16.0038 11.1944 16.5423 10.4667C17.0807 11.1944 17.9197 11.6635 18.8628 11.6635C20.4842 11.6635 21.8022 10.2749 21.8022 8.56939C21.8022 8.5187 21.796 8.46787 21.7837 8.41966H21.7838Z",
    fill: "#D8D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts3);
export default __webpack_public_path__ + "static/media/products3.0066ae65b40d7ea9bab7b007c8a43eb6.svg";
export { ForwardRef as ReactComponent };